import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { StorefrontCollectionInfo } from "src/types/graphql.d";

interface StorefrontCollectionVars {
  slug: string;
}

interface StorefrontCollectionData {
  storefrontCollection: StorefrontCollectionInfo;
}

export const GET_STOREFRONT_COLLECTION = gql`
  query storefrontCollection($slug: String!) {
    storefrontCollection(slug: $slug) {
      id
      name
      slug
      title
      subtitle
      url
      mobileImage
      desktopImage
      publishStartDate
      publishEndDate
      plpQuery
      targetType
    }
  }
`;

const useStorefrontCollection = (slug: string) => {
  const { loading, error, data } = useQuery<
    StorefrontCollectionData,
    StorefrontCollectionVars
  >(GET_STOREFRONT_COLLECTION, {
    variables: { slug },
    ssr: true,
    fetchPolicy: "cache-first",
  });

  const transformData =
    data && !loading
      ? {
          storefrontCollection: {
            ...data.storefrontCollection,
          },
        }
      : undefined;

  return { loading, error, data: transformData?.storefrontCollection };
};

export { useStorefrontCollection };
